import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { desktopTheme as t } from '../styles/desktopTheme';

const AppBarContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: var(--sidebar-width, 320px); /* Sidebar width (controlled by DesktopLayout) */
  right: 0;
  background: ${t.bg};
  border-top: 1px solid ${t.borderSubtle};
  padding: 16px 32px;
  z-index: 50;
  transition: left 200ms ease;
`;

const AppGrid = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
`;

const AppItem = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
  min-width: 64px;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;

const AppIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: ${props => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: transform 0.2s ease;
  box-shadow: ${props => props.active ? `0 0 0 2px ${props.color}, 0 0 0 4px rgba(255,255,255,0.3)` : 'none'};

  ${AppItem}:hover & {
    transform: scale(1.05);
  }
`;

const AppLabel = styled.span`
  font-size: 10px;
  color: ${t.textSecondary};
  text-align: center;
  white-space: nowrap;
`;

const APPS = [
  // Colors tuned to match the desktop mock
  { id: 'data', label: 'Data', color: '#FF2300', path: '/data' },
  { id: 'catalog', label: 'Catalog', color: '#17A2B8', path: '/catalog' },
  { id: 'bookings', label: 'Bookings', color: '#FFE600', path: '/bookings' },
  { id: 'tour-manager', label: 'TourMngr', color: '#FF9F0A', path: '/tour-manager' },
  { id: 'email', label: 'Email', color: '#DADDE1', path: '/email' },
  { id: 'tasks', label: 'Tasks', color: '#00C7D7', path: '/tasks' },
  { id: 'flows', label: 'Workflows', color: '#A3FF00', path: '/flows' },
  { id: 'teams', label: 'Teams', color: '#7B61FF', path: '/team-management' },
  { id: 'notes', label: 'Notes', color: '#F5F5F7', path: '/notes' },
  { id: 'contacts', label: 'Contacts', color: '#C6A574', path: '/contacts' },
  { id: 'analytics', label: 'Analytics', color: '#34C759', path: '/analytics' },
  { id: 'knowledge', label: 'Knowledge', color: '#FF2D9A', path: '/knowledge-base' },
];

export default function DesktopAppBar() {
  const navigate = useNavigate();
  const location = useLocation();

  const isAppActive = (appPath) => {
    return location.pathname.startsWith(appPath);
  };

  return (
    <AppBarContainer>
      <AppGrid>
        {APPS.map((app) => (
          <AppItem 
            key={app.id}
            onClick={() => navigate(app.path)}
          >
            <AppIcon 
              color={app.color}
              active={isAppActive(app.path)}
            />
            <AppLabel>{app.label}</AppLabel>
          </AppItem>
        ))}
      </AppGrid>
    </AppBarContainer>
  );
}

